import { useState } from 'react';

const faqs = [
  {
    question: 'What does HVAC training usually cover?',
    answer:
      'Most introductory programs combine safety, tools, refrigeration principles, electrical theory, air distribution, motors, controls, heating systems, cooling systems, preventive maintenance, and system diagnostics. Strong hands-on programs also let students practice reading wiring diagrams, using meters, identifying components, and troubleshooting common equipment problems.',
  },
  {
    question: 'Should I look for EPA Section 608 certification preparation?',
    answer:
      'Yes. Technicians who handle regulated refrigerants generally need EPA Section 608 certification. Ask each Houston-area school whether its curriculum prepares students for the appropriate certification exam, whether testing is included, and which certification types the program supports. Confirm current federal requirements through the EPA before enrolling.',
  },
  {
    question: 'Is online HVAC training enough to become job-ready?',
    answer:
      'Online study can be valuable for theory, terminology, safety, and flexible learning. However, HVAC work is highly practical. Students should look for access to mechanical labs, electrical practice, diagnostic equipment, instructor demonstrations, or supervised field experience whenever possible.',
  },
  {
    question: 'How long does it take to complete an HVAC program?',
    answer:
      'Program length ranges from short career certificates to longer technical pathways. The right choice depends on your schedule, previous experience, desired credential, and target role. Ask about total clock hours, lab hours, attendance requirements, and whether the published timeline assumes full-time enrollment.',
  },
  {
    question: 'What should I ask a school before applying?',
    answer:
      'Ask for the complete tuition and fee breakdown, tool costs, books, class times, lab access, instructor experience, EPA preparation, credential details, job placement support, refund policies, admission requirements, and whether the program has relationships with Houston-area employers.',
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="directory section" id="faq">
      <div className="section-heading">
        <p className="eyebrow">Plan with confidence</p>
        <h2>Houston HVAC Training FAQs</h2>
        <p>
          Use these answers as a starting point while comparing Houston-area
          programs. A school representative should provide the most current
          information about curriculum, credentials, costs, and enrollment.
        </p>
      </div>

      <div className="accordion-stack">
        {faqs.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <article
              className={`program-card ${isOpen ? 'open' : ''}`}
              key={faq.question}
            >
              <button
                className="program-trigger"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
              >
                <strong>{faq.question}</strong>
                <span aria-hidden="true">{isOpen ? '−' : '+'}</span>
              </button>
              {isOpen && (
                <div className="program-inner">
                  <p>{faq.answer}</p>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default FAQ;